import React from "react"
import SocialIcon from "@kit/design/social-icon"
import Icon from "@kit/design/icon"
import { SettingsButton } from "./settings-button"
import { useChildElements } from "../utils/use-child-elements"
import { useEditingContext, useElement } from "../data/form-data"
import { useBuilderState } from "app/forms/builder/builder-context"

import "./icons-element.css"

function IconLink({ element_id, settings, ...props }) {
  const [element] = useElement(element_id)
  const { url } = element
  const editing = useEditingContext()
  const { setActiveElement } = useBuilderState()
  const handleClick = () => setActiveElement(element_id)

  const onKeyPress = event => {
    if (event.key === "Enter") {
      handleClick()
    }
  }

  const { iconName } = props

  let classes = ""
  const iconStyles = {
    width: 40,
    height: 40
  }

  if (settings.iconColorStyle === "custom") {
    iconStyles.color = settings.iconColor

    if (settings.iconStyle == "icon") {
      classes = `text-lg bg-transparent`
    } else {
      iconStyles.backgroundColor = settings.iconBackgroundColor

      switch (settings.iconStyle) {
        case "round":
          classes = `rounded-full p-2`
          break
        case "square":
          classes = `rounded p-2`
          break
      }
    }
  } else {
    switch (settings.iconStyle) {
      case "icon":
        classes = `text-brand-${iconName} text-lg bg-transparent platform`
        break
      case "round":
        classes = `rounded-full p-2 text-white bg-brand-${iconName} platform`
        break
      case "square":
        classes = `rounded p-2 text-white bg-brand-${iconName} platform`
        break
    }
  }

  if (editing) {
    return (
      <div
        className={`flex justify-center items-center ${classes} icon`}
        style={iconStyles}
        onKeyPress={onKeyPress}
        onClick={handleClick}
        role="button"
        tabIndex="0"
      >
        <SocialIcon name={iconName} />
      </div>
    )
  } else if (url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className={`flex justify-center items-center ${classes} icon`}
        style={iconStyles}
      >
        <SocialIcon name={iconName} />
      </a>
    )
  } else {
    return null
  }
}

function IconInserter({ addIcon }) {
  const addStyles = {
    height: 40,
    width: 40
  }

  return (
    <button
      className={`cursor-pointer flex items-center justify-center bg-gray-50 hover:border-transparent hover:bg-gray-300 hover:text-gray-800 transition duration-300`}
      onClick={addIcon}
      style={{
        borderRadius: 999,
        ...addStyles
      }}
    >
      <Icon name="plus-circle" style={addStyles} />
      <span className="sr-only">Add an icon</span>
    </button>
  )
}

function IconCollection({ settings, style, icons, addIcon }) {
  const editing = useEditingContext()
  const { iconAlignment } = settings

  return (
    <div
      className="flex gap-3 max-w-screen-sm flex-wrap"
      style={{ justifyContent: iconAlignment, ...style }}
    >
      {icons.map(icon => (
        <IconLink key={icon.element_id} {...icon} settings={settings} />
      ))}

      {editing && <IconInserter settings={settings} addIcon={addIcon} />}
    </div>
  )
}

export function IconContainer({ element_id, ...props }) {
  const { children: icons, addChild } = useChildElements(
    "parent_element_id",
    element_id
  )
  const { editing } = props
  const { setActiveElement } = useBuilderState()

  const addIcon = () => {
    const newIcon = addChild({
      type: "Icon",
      url: "https://twitter.com",
      iconName: "x-twitter"
    })

    setActiveElement(newIcon[0].element_id)
  }

  const styles = {
    fontSize: `20px`
  }

  const iconsProps = {
    settings: props,
    style: styles,
    icons,
    addIcon
  }

  return (
    <div className="mt-4 mb-4 formkit-icons">
      {editing && (
        <div className="flex justify-between items-center mb-4">
          <SettingsButton onClick={props.onClick} />
        </div>
      )}

      <IconCollection {...iconsProps} />
    </div>
  )
}

IconContainer.componentType = "Icons"
